export class Icon {
  css = "";
  color = "";
  title?: string;
}

export class Utox {
  date?: string;
  failed?: boolean;
  color?: string;
  css?: string;
  udsItems: Uds[] = [];
}

export class Uds {
  patientId = "";
  firstName = "";
  lastName = "";
  dob = "";
  testName = "";
  results = "";
  abnormalFlags = "";
  observationDate?: string;
  rangeLow = "";
  rangeHigh = "";
}

export class Annotation {
  id = "";
  type = "";
  xMin?: number; 
  xMax?: number;
  yMin?: number; 
  yMax?: number;
  borderColor?: string;
  borderWidth?: number;
  backgroundColor?: string;
  z?: number;
}

export class Options {
  responsive = false;
  maintainAspectRatio = false;
  plugins!: Plugins;
  scales!: Scales;
}

class Plugins {
  datalabels!: Datalabels;
  propagate = false;
  legend!: Legend;
  annotation!: Annotations;
}

class Datalabels {
  clip?: boolean;
  display = false;
  align?: string;
  font?: (context: any) => Font;
  formatter?: any;
}

class Font {
  weight = "";
  size = 0;
}

class Legend {
  display = false;
}

class Annotations {
  common!: Common;
  annotations: Annotation[] = [];
}

class Common {
  drawTime = "";
}

class Scales {
  y!: Y;
}

class Y {
  max = 0;
  min = 0;
  ticks!: Ticks;
}

class Ticks {
  stepSize = 0;
}

export class ChartData {
  labels: string[][] = [];
  datasets: Dataset[] = [];
}

class Dataset {
  pointBackgroundColor!: (value: any) => string;
  borderColor = "";
  parsing = false;
  borderWidth = 0;
  pointRadius!: (context: any) => number;
  datalabels!: Datalabels;
  data: Data[] = [];
  spanGaps = false;
}

export class DataContent {
  median = "";
  high = "";
  low = "";
  dataSet: Data[] = [];
  dataPoints: DataPoint[] = [];
}

export class Assessment {
  median = "";
  high = "";
  low = "";
}

export class Data {
  x = 0.0;
  y = 0;
  assessmentIds: number[] = [];
  assessmentDates: string[] = [];
  assessmentValues: number[] = [];
  isAssessment = true;
}

export class DataPoint {
  multiple = true;
  y = 0;
  x = 0.0;
}

export class AlertZone {
  color = "";
  startZone = 0;
  endZone = 0;
}

export class PatientAudit {
  user = "";
  patientId = "";
}

export class AssessmentResult {
  choices: AssessmentChoice[] = [];
  question = "";
  answer = "";
}

export class AssessmentChoice {
  id = 0;
  questionId = 0;
  choice = "";
  displayOrder = 0;
  value = 0;
}

export class AssessmentHistory {
  name = "";
  description = "";
  status = 0;
  assessmentDate = "";
  createdDate = "";
  expiryDate = "";
  triggerType = 0;
  totalScore = 0;
}

export class Biometrics {
  minBpm?: number;
  maxBpm?: number;
  minHrMad?: number;
  maxHrMad?: number;
  minBr?: number;
  maxBr?: number;
  minSpo2?: number;
  maxSpo2?: number;
  minTObject?: number;
  maxTObject?: number;
  sleepDuration?: string;
  localTime = ""; 
}

export class BiometricResults {
  bpmAvg?: number;
  hrMadAvg?: number;
  brAvg?: number;
  spo2Avg?: number;
  tObjectAvg?: number;
  minutesPerHour?: number;
  sleepStart?: string;
  sleepEnd?: string;
  localTime = ""; 
}

export class BasicNeeds {
  income?: string;
  transportation?: string;
  housing?: string;
}

export enum LevelColor {
  MostSevere = "#FAABAB",
  Severe = "#F6DDAD",
  Moderate = "#F9E7C4",
  Mild = "#C5DAB4",
  Minimal = "#DFEBD6"
}

export enum AssessmentTypes {
  GAD7 = 1,
  PHQ9 = 2,
  SOWS = 3,
  Cravings = 4,
  BAM = 5
}